import normalizeComponent from "../../../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "&#229;&#174;&#140;&#230;&#136;&#144;" } }, [_c("g", { attrs: { "id": "Union" } }, [_c("path", { attrs: { "d": "M5.58415 10.0766L9.18049 13.7057L14.6341 7.55313L13.5742 6.66683L8.97862 10.9393L6.42575 9.16797L5.58415 10.0766Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M19.1673 10.0002C19.1673 15.0628 15.0633 19.1668 10.0007 19.1668C4.93804 19.1668 0.833984 15.0628 0.833984 10.0002C0.833984 4.93755 4.93804 0.833496 10.0007 0.833496C15.0633 0.833496 19.1673 4.93755 19.1673 10.0002ZM17.5006 10.0002C17.5006 14.1423 14.1428 17.5002 10.0007 17.5002C5.85851 17.5002 2.50065 14.1423 2.50065 10.0002C2.50065 5.85803 5.85851 2.50016 10.0007 2.50016C14.1428 2.50016 17.5006 5.85803 17.5006 10.0002Z", "fill": "currentColor" } })])])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const success = __component__.exports;
export {
  success as default
};
